module.exports = __webpack_public_path__ + "static/annotation-comment-2-ebe5ea08599c70c70e84df9ddc32e345.png";